"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronUp = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const ChevronDown_1 = require("./ChevronDown");
const ChevronUp = ({ colour = "#E6E6E6", size = 16, title = "Collapse section" }) => (react_1.default.createElement(ChevronDown_1.ChevronDown, { colour: colour, size: size, title: title, style: { transform: "rotate(180deg)", transformOrigin: "50%" } }));
exports.ChevronUp = ChevronUp;
//# sourceMappingURL=ChevronUp.js.map